import { getAuthTranslatedKey, getTaskTranslatedKey } from '../../constants/text/utils';

const useConstLang = () => {
  const logoutButtonText = getAuthTranslatedKey('logoutButtonText');
  const siteTitle = getAuthTranslatedKey('siteTitle');
  const cancelWarning = getTaskTranslatedKey('cancelWarning');

  return {
    logoutButtonText,
    siteTitle,
    cancelWarning
  };
};

export default useConstLang;